import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { WebTermsConditions } from '@cl/shared/models/web-terms-conditions.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class WebTermsConditionsService extends BaseService<WebTermsConditions> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/web-terms-conditions/');
    }
}
